export const SALES_REPORT_GRAPH_ELEMENT_ID = 'sales-report-graph'
